export const SCRIPT = '<script src="{{MANAGER_SCRIPT}}/{{BOX_ID}}/script"></script>';
export const TRIGGER_BUTTON_ATTR = 'data-kbx-trigger-button';



/** WEBPACK FOOTER **
 ** ./src/helpers/code/config.js
 **/